import './Footer.css';

export function Footer() {
  return (
    <div className="footer">
      <a target="_blank" rel="noreferrer" href="https://www.flaticon.com/free-icons/zoology" title="zoology icons">Zoology icons created by smalllikeart - Flaticon</a>
    </div>
  )
}
